export enum Users  {
    ADMIN = 1,
    STUDENT = 2,
    TEACHER = 3,
    DOCTOR = 4,
    PARENT = 5
}